import { config_settings } from '@/config.js';
import Vue from 'vue';

export const postLogin = (body_credentials) => {
  return Vue.$http({
    method: 'post',
    url: config_settings.AUTH_SERVER_URL + '/oauth/token',
    data: body_credentials,
    withCredentials: true,
    auth: {
      username: 'USER_CLIENT_APP',
      password: 'password',
    },
  });
};

export const getProfileData = (token) => {
  return Vue.$http({
    method: 'get',
    url: config_settings.RESOURCE_SERVER_URL + '/GET/profile',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const putPassword = (jsonObject) => {
  return Vue.$http({
    method: 'PUT',
    url: config_settings.RESOURCE_SERVER_URL + '/PUT/forget_password',
    data: jsonObject,
  });
};
